import {useSelector} from "react-redux";
import {RootState} from "../components/Store";

export const useIsLoggedUser = () => {
    return useSelector((root: RootState) => root.currentUser);

}